import StudentsList from './StudentsList.container';

export default StudentsList;
